import React, { Component } from "react";
import { withTranslation } from "react-i18next";

class ContactCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { t } = this.props;

    return (
      <div className="loginPage">
        <section className="login_form">
          <div className="loginIntroTextContainer">
            <h3>{t("cc_title")} </h3>
            <p className="headerdescription">{t("cc_message")} </p>
          </div>
          <div className="tabs">
            <div className="tab-content">
              <button
                onClick={() => {
                  this.props.setShowCC(false);
                  this.props.setShowMasterLine(false);
                  this.props.setShowResetPassword(false, this.props.userName);
                  this.props.setShowActivation(true);
                }}
                className="btn min_outlin_btn active"
              >
                {t("done_btn")}{" "}
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default withTranslation()(ContactCenter);
